export const FIRST_LOGIN_ONBOARDING_STORAGE_KEY =
  "lokasi:onboarding:first-login:v1";

const PENDING_STATUS = "pending";
const COMPLETED_STATUS = "completed";

type FirstLoginOnboardingStatus =
  | typeof PENDING_STATUS
  | typeof COMPLETED_STATUS;

const getStorage = () => {
  if (typeof window === "undefined") return null;
  return window.localStorage;
};

const readFirstLoginOnboardingStatus =
  (): FirstLoginOnboardingStatus | null => {
    try {
      const value = getStorage()?.getItem(FIRST_LOGIN_ONBOARDING_STORAGE_KEY);
      if (value === PENDING_STATUS || value === COMPLETED_STATUS) return value;
      return null;
    } catch {
      return null;
    }
  };

const writeFirstLoginOnboardingStatus = (
  status: FirstLoginOnboardingStatus
) => {
  try {
    getStorage()?.setItem(FIRST_LOGIN_ONBOARDING_STORAGE_KEY, status);
  } catch {
    // localStorage is a temporary fallback until first_login_completed is API-backed.
  }
};

export const queueFirstLoginOnboarding = () => {
  const status = readFirstLoginOnboardingStatus();
  if (status === COMPLETED_STATUS || status === PENDING_STATUS) return;

  writeFirstLoginOnboardingStatus(PENDING_STATUS);
};

export const shouldShowFirstLoginOnboarding = () =>
  readFirstLoginOnboardingStatus() !== COMPLETED_STATUS;

export const completeFirstLoginOnboarding = () => {
  writeFirstLoginOnboardingStatus(COMPLETED_STATUS);
};
